module.exports = __webpack_public_path__ + "img/list_marker.e2c1a835.svg";